// extracted by mini-css-extract-plugin
var _1 = "nsbkX";
var _2 = "Jlvme";
var _3 = "isIbU";
var _4 = "FQBrN";
var _5 = "C9UpV";
var _6 = "cA1Q9";
var _7 = "eSt_R";
var _8 = "SgfPg";
var _9 = "lmxRb";
var _a = "yxi2K";
var _b = "Fkhs6";
var _c = "ZBtSN";
var _d = "_6HuWy";
var _e = "mm5xL";
var _f = "Hdozd";
var _10 = "MSslv";
var _11 = "iLeR3";
var _12 = "u7fwW";
var _13 = "zzTrz";
var _14 = "BrPLD";
var _15 = "jHQK8";
var _16 = "bO2SD";
var _17 = "Sy3MN";
var _18 = "KY6cE";
export { _1 as "base", _2 as "edge-flat", _3 as "edge-none", _4 as "edge-rounded", _5 as "full-width", _6 as "icon", _7 as "icon-only", _8 as "inline", _9 as "loading", _a as "size-auto", _b as "size-lg", _c as "size-md", _d as "size-sm", _e as "size-xl", _f as "size-xs", _10 as "theme-dark", _11 as "theme-light", _12 as "variant-ghost", _13 as "variant-help", _14 as "variant-primary", _15 as "variant-secondary", _16 as "variant-secondary-blue", _17 as "variant-special", _18 as "variant-tertiary" }
